module.exports = "<p>\n  register works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/kepler/code/github/expense-manager-firebase/src/app/register/register.component.html
// module id = ../../../../../src/app/register/register.component.html
// module chunks = 1